import React from "react";
import Footer from "../components/Footer.jsx";
import Facture from "../components/Facture.jsx";

export default function Paiement(){
    return(
        <div>
            <Facture/>
            <Footer/>
        </div>
    )
}




